<!--
* @Author : DingHuiHui
* @Content : 图形验证码
-->
<template>
  <canvas width="120" height="40" ref="canvasEl" @click="draw"></canvas>
</template>

<script>
export default {
  data () {
    return {
      codeCanvas: null,
      arr: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'],
      strStore: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    }
  },
  mounted () {
    this.draw()
  },
  methods: {
    /**
     * 绘制图形验证码
     */
    draw () {
      this.codeCanvas = this.$refs.canvasEl
      const context = this.codeCanvas.getContext('2d')
      context.strokeRect(0, 0, 120, 40)
      context.clearRect(0, 0, 120, 40) // 清除画布
      let codeStr = '' // code
      for (let i = 0; i < 4; i++) {
        const x = i * 20 + 20
        const y = 20 + 10 * Math.random()
        context.font = 'bold 20px 微软雅黑'
        context.translate(x, y)
        const deg = Math.random() * 90 * Math.PI / 180
        context.rotate(deg) // 使画布旋转任意角度实现验证码不规则旋转
        const oneStr = this.strStore[this.roundNum(0, this.strStore.length)]
        codeStr += oneStr
        context.fillText(oneStr, 0, 0) // 填充文字
        context.rotate(-deg)
        context.translate(-x, -y)
        context.fillStyle = this.ranColor()
      }
      // 10个左右的随机（长度随机，位置随机），干扰线
      for (let i = 0; i < this.roundNum(5, 10); i++) {
        context.beginPath()
        context.moveTo(this.roundNum(0, 100), this.roundNum(0, 40))
        context.lineTo(this.roundNum(0, 100), this.roundNum(0, 40))
        context.strokeStyle = this.ranColor()
        context.stroke()
      }
      // 10个左右的随机（半径随机，位置随机）干扰圆
      for (let i = 0; i < this.roundNum(5, 10); i++) {
        context.beginPath()
        context.fillStyle = this.ranColor()
        context.arc(this.roundNum(0, 100), this.roundNum(0, 40), this.roundNum(0, 5), Math.PI * 2 / (this.roundNum(1, 360)), Math.PI * 2 / (this.roundNum(1, 360)))
        context.fill()
      }
      this.$emit('on-code', codeStr)
    },
    /**
     * 随机函数
     */
    roundNum (min, max) {
      return parseInt(Math.random() * (max - min) + min)
    },
    /**
     * 获取随机颜色
     */
    ranColor () {
      return `rgb(${this.roundNum(0, 255)}, ${this.roundNum(0, 255)}, ${this.roundNum(0, 255)})`
    }
  }
}
</script>

<style scoped>
canvas {
  border: 1px solid #eee;
}
</style>
